import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {UploaderComponent} from '../shared';
import {NzModalService} from 'ng-zorro-antd';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private baseUrl = environment.uploadBaseUrl;
  private baseUrlImage = environment.uploadImageBaseUrl;
  private urlPdf =
    'https://upload.icheck.vn/v1/file?uploadType=simple&responseType=json';
    // "https://upload.icheck.com.vn/upload/stream"
  private urlVideo = 'https://upload.icheck.com.vn/upload/stream';

  constructor(private http: HttpClient, private modalService: NzModalService) {}

  public create(size: number, metadata: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/upload`, { size, metadata });
  }

  public createFlash(body): Observable<any> {
    return this.http.post(`${this.baseUrlImage}`, body);
  }

  public uploadPdf(body): Observable<any> {
    return this.http.post(`${this.baseUrlImage}`, body);
  }

  public getFile(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/files/${id}`, {
      params: { fields: ['source', 'metadata'] },
    });
  }

  public uploadVideo(body): Observable<any> {
    console.log(body);
    return this.http.post(`${this.urlVideo}`, body);
  }

  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      }
    });
    modal.afterOpen.pipe().subscribe(() => {
      modal.getContentComponent().change.subscribe(changeParam => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          console.log('data', data);
          this[field] = [];
          this[field].push(data);
        }
      });
      modal.getContentComponent().done.pipe().subscribe(changeParam => {
        modal.close();
      });
    });
  }
}
